import {
  justLog,
  Console,
  JustEatLoggingService,
  Level
} from '@justeat/just-log'
import * as Sentry from '@sentry/vue'
import helpers from './helpers'

export default class logger {
  static setupLogging(
    environment,
    tenant,
    loggingBaseUrl,
    applicationVersion,
    additionalProperties = {}
  ) {
    justLog.forFeature({
      name: 'consumerhelpweb',
      version: applicationVersion,
      environment,
      tenant,
      additionalProperties
    })

    justLog.to(new Console())

    if (environment !== 'development') {
      justLog.to(new JustEatLoggingService(loggingBaseUrl))
    }

    justLog.withContext(() => ({
      route: window.location.pathname
    }))

    justLog.downToLevel(Level.Info)
  }

  static debug(message, args) {
    justLog.debug(message, args)
  }

  static info(message, args) {
    justLog.info(message, args)
  }

  static warn(message, args) {
    justLog.warn(message, args)
    Sentry.captureMessage(message, args)
  }

  static error(message, args) {
    const logMessage = helpers.typeToString(message)
    justLog.error(logMessage, args)
  }
}
